import React from 'react';

const Logo = ({ height = 56, color }) => {
  const scale = height / 88;
  const textFill = color || 'currentColor';
  const taglineFill = color ? 'rgba(255,255,255,0.6)' : '#94a3b8';
  return (
    <svg
      width={Math.round(460 * scale)}
      height={height}
      viewBox="0 0 460 88"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <rect x="0" y="0" width="64" height="64" rx="16" fill="#1d4ed8"/>
      <rect x="14" y="26" width="36" height="12" rx="3" fill="#ffffff"/>
      <rect x="26" y="14" width="12" height="36" rx="3" fill="#ffffff"/>
      <circle cx="32" cy="32" r="5" fill="#93c5fd"/>
      <text
        x="84" y="40"
        fontFamily="'Helvetica Neue', Arial, sans-serif"
        fontSize="36"
        fontWeight="700"
        letterSpacing="-0.5"
        fill={textFill}
      >SpecialistHub</text>
      <text
        x="86" y="60"
        fontFamily="'Helvetica Neue', Arial, sans-serif"
        fontSize="11"
        fontWeight="400"
        letterSpacing="2.5"
        fill={taglineFill}
      >ZIMBABWE SPECIALIST APPOINTMENTS</text>
    </svg>
  );
};

export default Logo;
